import type { MemberPin, PinKind } from '@/lib/api/types';

/** Release 1 S1 — pure helpers for the member's pin list (the server keeps the order; we mirror it). */

export function findPin(items: readonly MemberPin[] | undefined, kind: PinKind, targetId: string): MemberPin | undefined {
  return items?.find((p) => p.kind === kind && p.target_id === targetId);
}

export function isPinned(items: readonly MemberPin[] | undefined, kind: PinKind, targetId: string): boolean {
  return !!findPin(items, kind, targetId);
}

/**
 * Move `dragId` so it lands where `overId` currently is (before it when dragging up, after it when
 * dragging down). Returns the same array when nothing changes.
 */
export function reorderPins<T extends { id: string }>(items: readonly T[], dragId: string, overId: string): T[] {
  const from = items.findIndex((p) => p.id === dragId);
  const to = items.findIndex((p) => p.id === overId);
  if (from < 0 || to < 0 || from === to) return items as T[];
  const next = [...items];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved!);
  return next;
}

/** Renumber `sort_order` after a local reorder so optimistic UI matches what the server returns. */
export function renumber(items: readonly MemberPin[]): MemberPin[] {
  return items.map((p, i) => (p.sort_order === i ? p : { ...p, sort_order: i }));
}

export function pinLabel(p: MemberPin): string {
  return p.kind === 'board' ? (p.board?.name ?? 'Board') : (p.asset?.title ?? 'Asset');
}

export function pinHref(ws: string, p: MemberPin): string {
  return p.kind === 'board' ? `/w/${ws}/b/${p.target_id}` : `/w/${ws}/a/${p.target_id}`;
}
